import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useDeleteCall } from '../../lib/api/delete'
import { useUpdateCall } from '../../lib/api/update'

export const EditModal = ({ isLocalEnvironment, setOpenManage, defaultData }) => {
  const deleteCallMutation = useDeleteCall()
  const updateCallMutation = useUpdateCall()
  const [deleteConfirm, setDeleteConfirm] = React.useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()

    const data = new FormData(e.target)
    const checkInDateTime = dayjs(`${data.get('checkInDate')} ${data.get('checkInTime')}`).format(
      'YYYY-MM-DD HH:mm:ss',
    )
    const checkInConfirmDateTime = dayjs(
      `${data.get('checkInConfirmDate')} ${data.get('checkInConfirmTime')}`,
    ).format('YYYY-MM-DD HH:mm:ss')
    const checkOutDateTime = dayjs(
      `${data.get('checkOutDate')} ${data.get('checkOutTime')}`,
    ).format('YYYY-MM-DD HH:mm:ss')
    const checkOutConfirmDateTime = dayjs(
      `${data.get('checkOutConfirmDate')} ${data.get('checkOutConfirmTime')}`,
    ).format('YYYY-MM-DD HH:mm:ss')

    const formData = defaultData
    defaultData['checkInDateTime'] = checkInDateTime
    defaultData['checkInConfirmedDateTime'] = checkInConfirmDateTime
    defaultData['checkOutDateTime'] = checkOutDateTime
    defaultData['checkOutConfirmedDateTime'] = checkOutConfirmDateTime

    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'attendance',
      invalidateWithParams: true,
      data: formData, // data,
      id: defaultData.attendanceId,
      messageTitle: 'Attendance',
      message: 'Attendance updated successfully!',
      params: '',
      isDynamic: true,
    })
  }

  const onDelete = async () => {
    await deleteCallMutation.mutateAsync({
      url: isLocalEnvironment + '/deleteData',
      apiEndpoint: 'attendance',
      id: defaultData.attendanceId,
      messageTitle: 'Attendance',
      message: 'Attendance deleted successfully!',
      params: '',
      isDynamic: true,
    })
    setDeleteConfirm(false)
    setOpenManage(false)
  }

  return (
    <div
      className="trtui-modal trtui-modal-xxl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xxl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Manage Attendance
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                setOpenManage(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-card">
              <div className="trtui-card-body trtui-p-4">
                {deleteConfirm ? (
                  <div>
                    <div className="trtui-mt-2 trtui-text-center">
                      <lord-icon
                        src="https://cdn.lordicon.com/gsqxdxog.json"
                        trigger="loop"
                        colors="primary:#f7b84b,secondary:#f06548"
                        style={{ width: '100px', height: '100px' }}
                      />
                      <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                        <h4>Are you Sure ?</h4>
                        <p className="trtui-text-muted trtui-mx-4 trtui-mb-0">
                          Are you Sure You want to Remove this Attendance ?
                        </p>
                      </div>
                    </div>
                    <div className="trtui-d-flex trtui-gap-2 trtui-justify-content-center trtui-mt-4 trtui-mb-2">
                      <button
                        type="button"
                        className="trtui-btn trtui-w-sm trtui-btn-light"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          setDeleteConfirm(false)
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="trtui-btn trtui-w-sm trtui-btn-danger"
                        onClick={() => onDelete()}
                      >
                        Yes, Delete It!
                      </button>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={(e) => onSubmit(e)}>
                    <div className="trtui-row">
                      <label>Check-In</label>
                      <div className="trtui-col-6">
                        <input
                          type="date"
                          className="trtui-form-control"
                          name="checkInDate"
                          value={dayjs(defaultData['checkInDateTime']).format('YYYY-MM-DD')}
                        />
                      </div>
                      <div className="trtui-col-6">
                        <input
                          type="time"
                          className="trtui-form-control"
                          name="checkInTime"
                          defaultValue={dayjs(defaultData['checkInDateTime']).format('HH:mm')}
                        />
                      </div>
                    </div>
                    <div className="trtui-row">
                      <label>Check-In Confirm</label>
                      <div className="trtui-col-6">
                        <input
                          type="date"
                          className="trtui-form-control"
                          name="checkInConfirmDate"
                          defaultValue={dayjs(defaultData['checkInConfirmedDateTime']).format(
                            'YYYY-MM-DD',
                          )}
                        />
                      </div>
                      <div className="trtui-col-6">
                        <input
                          type="time"
                          className="trtui-form-control"
                          name="checkInConfirmTime"
                          defaultValue={dayjs(defaultData['checkInConfirmedDateTime']).format(
                            'HH:mm',
                          )}
                        />
                      </div>
                    </div>
                    <div className="trtui-row">
                      <label>Check-Out</label>
                      <div className="trtui-col-6">
                        <input
                          type="date"
                          className="trtui-form-control"
                          name="checkOutDate"
                          defaultValue={dayjs(defaultData['checkOutDateTime']).format('YYYY-MM-DD')}
                        />
                      </div>
                      <div className="trtui-col-6">
                        <input
                          type="time"
                          className="trtui-form-control"
                          name="checkOutTime"
                          defaultValue={dayjs(defaultData['checkOutDateTime']).format('HH:mm')}
                        />
                      </div>
                    </div>
                    <div className="trtui-row">
                      <label>Check-Out Confirm</label>
                      <div className="trtui-col-6">
                        <input
                          type="date"
                          className="trtui-form-control"
                          name="checkOutConfirmDate"
                          defaultValue={dayjs(defaultData['checkOutConfirmedDateTime']).format(
                            'YYYY-MM-DD',
                          )}
                        />
                      </div>
                      <div className="trtui-col-6">
                        <input
                          type="time"
                          className="trtui-form-control"
                          name="checkOutConfirmTime"
                          defaultValue={dayjs(defaultData['checkOutConfirmedDateTime']).format(
                            'HH:mm',
                          )}
                        />
                      </div>
                    </div>
                    <div className="trtui-row trtui-mt-2">
                      <div className="trtui-col-12">
                        <button
                          type="submit"
                          disabled={updateCallMutation.isLoading || deleteCallMutation.isLoading}
                          className="trtui-btn trtui-btn-primary"
                        >
                          {updateCallMutation.isLoading ? (
                            <span className="trtui-d-flex trtui-align-items-center">
                              <span className="trtui-flex-grow-1 trtui-me-2">Updating...</span>
                              <span
                                className="trtui-spinner-border trtui-flex-shrink-0"
                                role="status"
                              >
                                <span className="trtui-visually-hidden">Updating...</span>
                              </span>
                            </span>
                          ) : (
                            'Update'
                          )}
                        </button>{' '}
                        <button
                          type="button"
                          disabled={updateCallMutation.isLoading || deleteCallMutation.isLoading}
                          onClick={() => setDeleteConfirm(true)}
                          className="trtui-btn trtui-btn-danger"
                        >
                          {deleteCallMutation.isLoading ? (
                            <span className="trtui-d-flex trtui-align-items-center">
                              <span className="trtui-flex-grow-1 trtui-me-2">Deleting...</span>
                              <span
                                className="trtui-spinner-border trtui-flex-shrink-0"
                                role="status"
                              >
                                <span className="trtui-visually-hidden">Deleting...</span>
                              </span>
                            </span>
                          ) : (
                            'Delete'
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

EditModal.propTypes = {
  isLocalEnvironment: PropTypes.string,
  childFormData: PropTypes.object,
  setOpenManage: PropTypes.func,
  modSchema: PropTypes.object,
  defaultData: PropTypes.object,
}
